import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import StreamgraphChart from './components/StreamgraphChart'
import { HeaderChartProps, mainSeason, modalSeason, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import SourceLink from '../../component/chartLinkData'
interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  const [showSeasonModal, setShowSeasonModal] = useState(false)
  const [selectedAgeClass, setSelectedAgeClass] = useState<string[]>(['0-200'])

  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const HeaderChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      {' '}
      Influenza - Positivity rate among samples tested {season} (France - Lyon){' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
            <p>
              The graph shows the number of samples tested and the positivity rate for
              Influenza, SARS-CoV2, RSV and other respiratory viruses over the last
              week. Virological data are provided on a weekly basis by the Laboratoire
              de Biologie Médicale Multi Sites (LBMMS) from the Hospices Civils de Lyon.
              Data are available per respiratory virus and per age group (source BEHcl).
            </p>
          </Tooltip>
        }
      >
        <img
          //className='mb-1'
          style={{ width: '12px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
    </h2>
  )

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row g-5 g-xl-8'>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <HeaderChart season={null} />
              </div>
              <Card.Body className='row' style={{ marginTop: '-35px' }}>
                <StreamgraphChart
                  season={mainSeason}
                  selectedAgeClass={selectedAgeClass}
                  setSelectedAgeClass={setSelectedAgeClass}
                />

                <div className="d-flex justify-content-between align-items-center">
                  <p className='card-text source'>
                    <i>
                      Source:
                      <a className='fw-bold' href='https://www.chu-lyon.fr'>
                        {' '}
                        Hospices Civils de Lyon
                      </a>{' '}
                      , BEHcl
                    </i>{' '}
                  </p>
                  <SourceLink onClick={() => setShowSeasonModal(true)} />
                </div>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
      <Modal
        // size="xl"
        className="modal-xxl"
        show={showSeasonModal}
        onHide={() => setShowSeasonModal(false)}
        centered
      >
        <Modal.Header closeButton className='py-4'>
          <Modal.Title className='bold'>
            <HeaderChart season={'2023-2024'} />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body >
          <StreamgraphChart
            season={modalSeason}
            selectedAgeClass={selectedAgeClass}
            setSelectedAgeClass={setSelectedAgeClass}
          />
          <div className="d-flex justify-content-between align-items-center">
            <p className='card-text source'>
              <i>
                Source:
                <a className='fw-bold' href='https://www.chu-lyon.fr'>
                  {' '}
                  Hospices Civils de Lyon
                </a>{' '}
                , BEHcl
              </i>{' '}
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

const Influenza = () => {
  const intl = useIntl()
  return (
    <>
      <DashboardPage />
    </>
  )
}

export { Influenza }
